import SideBlockAds from "@components/Blocks/Container/SideBlockAds";
import UnsubscribeForm from "@components/Blocks/NewsLetterUnsubscribeForm/NewsLetterUnsubscribeForm";
import { getGTMData, getMetaData } from "@helper/getMetaData";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import BHBasePage, { BHBasePageProps } from "@src/app/routes/BHBasePage";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";

import styles from "./NewsletterUnsubscribe.module.css";

export function meta() {
  const uniqueSectionName = "eNewsLetter";
  const metaTags: MetaTagsProps = {
    title: "Berhenti Melanggan E-Newsletter - BeritaHarian.sg",
    slug: uniqueSectionName,
    description: "Berhenti Melanggan E-Newsletter Berita Harian.",
  };
  return [getMetaData(metaTags)];
}

export default function NewsletterUnsubscribePage() {
  const sectionName = "eNewsLetter";
  const newsletterPageProps: BHBasePageProps = {
    uniqueSectionName: sectionName,
    pageAdTargetValue: PageAdTargetingTypeEnum.LISTING,
  };

  return (
    <BHBasePage {...newsletterPageProps}>
      <div className="max-w-screen-xl m-auto flex flex-col lg:flex-row">
        <div className="flex lg:px-sm flex-col w-12/12 lg:w-8/12 w-full">
          <span className="text-blue-300 text-lg font-semibold">
            Berhenti Melanggan E-Newsletter
          </span>
          <div className="w-full pt-sm">
            <div className={styles.NewsletterUnsubscribeContainer}>
              <h3 className={styles.author}>
                Sila masukkan alamat e-mel anda{" "}
              </h3>
              <UnsubscribeForm />
            </div>
          </div>
        </div>
        <SideBlockAds
          pageAdTargetingProps={PageAdTargetingTypeEnum.LISTING}
          adsOnly={true}
        />
      </div>
    </BHBasePage>
  );
}

export function loader(): Promise<TRouteWithRedirect<object | null, string>> {
  const gaData: GADataProps = {
    level2: "miscellaneous",
    title: "E-Newsletter Unsubscribe",
    section: "miscellaneous",
    contentcat: "1",
    contenttype: "listing",
  };

  return Promise.resolve({
    type: ResponseType.SUCCESS,
    statusCode: 200,
    payload: null,
    cacheControlMaxAge: 300, // 5 minutes
    regenerateInterval: 172800, // 2 days
    gtm: getGTMData(gaData),
  });
}
